import { MenuData, SubCategory } from '@/types/menu';

// Extend subcategories for categories with byScenarios
interface ExtendedSubCategories {
  [key: string]: SubCategory;
}

interface EvChargingCategory extends Omit<MenuData['evCharging'], 'subcategories'> {
  subcategories: ExtendedSubCategories;
}

export const menuData: MenuData = {
  evCharging: {
    name: 'EV Charging',
    subcategories: {
      evcharger: {
        name: 'Portable EV Chargers',
        type: 'nested',
        subcategories: {
          charger: {
            name: 'EV Chargers',
            type: 'products',
            items: [
              {
                id: 'flex-ac-elite',
                name: 'Flex-AC Elite',
                specs: '32A 7.6kW/40A 9.6kW',
                image: '/images/product/evcharger/flex-ac-elite.webp',
                link: '/products/flex-ac-elite'
              },
              {
                id: 'flex-ac',
                name: 'Flex-AC',
                specs: '32A 7.6kW/40A 9.6kW',
                image: '/images/product/evcharger/flex-ac.webp',
                link: '/products/flex-ac'
              },
              {
                id: 'flex-ac-le',
                name: 'Flex-AC LE',
                specs: '40A 9.6kW',
                image: '/images/product/evcharger/flex-ac-le.webp',
                link: '/products/flex-ac-le'
              }
            ]
          }
        }
      },
      accessories: {
        name: 'Accessories',
        type: 'nested',
        viewAllLink: '/product-category/ev-accessories',
        subcategories: {
          adaptors: {
            name: 'Adaptors',
            type: 'products',
            items: [
              {
                id: 'nema-5-15-adaptor',
                name: 'NEMA 5-15P',
                specs: '12A EV Charger Adaptor',
                image: '/images/product/adaptor/nema-5-15.webp',
                link: '/products/nema-5-15-adaptor'
              },
              {
                id: 'nema-14-50-adaptor-32a',
                name: 'NEMA 14-50P',
                specs: '32A EV Charger Adaptor',
                image: '/images/product/adaptor/nema-14-50.webp',
                link: '/products/nema-14-50-32a-adaptor'
              },
              {
                id: 'name-5-15-40a',
                name: 'NEMA 14-50P',
                specs: '40A EV Charger Adaptor',
                image: '/images/product/adaptor/nema-15-50-40a.webp',
                link: '/products/nema-14-50-40a-adaptor'
              }
            ]
          },
          cases: {
            name: 'Flex-AC Cases & Wall-mount Units',
            type: 'products',
            items: [
              {
                id: 'silicone-case',
                name: 'Silicone Case',
                image: '/images/product/accessory/case/silicone-case.webp',
                link: '/products/silicone-case'
              },
              {
                id: 'wall-mount-bracket',
                name: 'Wall Mount Bracket',
                image: '/images/product/accessory/case/wall-mount-bracket.webp',
                link: '/products/wall-mount-bracket'
              },
              {
                id: 'back-extension',
                name: 'Back Extension',
                image: '/images/product/accessory/case/back-extension.webp',
                link: '/products/back-extension'
              }
            ]
          },
          holders: {
            name: 'Cable Holders',
            type: 'products',
            items: [
              {
                id: 'cable-holder',
                name: 'Charging Handle Holster and Cable Holder',
                image:
                  '/images/product/accessory/holder/charging-handle-holster-and-cable-holder.webp',
                link: '/products/charging-handle-holster-and-cable-holder'
              }
            ]
          }
        }
      }
    }
  },
  portablePowerStations: {
    name: 'Portable Power Stations',
    subcategories: {
      byProduct: {
        name: 'By Product',
        type: 'nested',
        subcategories: {
          batteries: {
            name: 'Batteries',
            type: 'products',
            viewAllLink: '/product-category/batteries',
            items: [
              {
                id: 'p201',
                name: 'P201',
                specs: '150W 148Wh',
                image: '/images/product/battery/P201.webp',
                link: '/products/p201'
              },
              {
                id: 'p302',
                name: 'P302',
                specs: '300W 296Wh',
                image: '/images/product/battery/P302.webp',
                link: '/products/p302'
              },
              {
                id: 'e600lfp',
                name: 'E600LFP',
                specs: '1200W 614Wh',
                image: '/images/product/battery/E600LFP.webp',
                link: '/products/e600lfp'
              },
              {
                id: 'e3600lfp',
                name: 'E3600LFP',
                specs: '3600W 3072Wh',
                image: '/images/product/battery/E3600LFP.webp',
                link: '/products/e3600lfp'
              },
              {
                id: 'trek-4200',
                name: 'Trek 4200',
                // specs: '3072Wh',
                image: '/images/products/trek-4200/products/T4.png',
                link: '/products/trek-4200'
              },
              {
                id: 'ep3000-48v',
                name: 'EP3000-48V',
                specs: '3072Wh',
                image: '/images/product/battery/EP3000-48V.webp',
                link: '/products/ep3000-48v'
              }
            ]
          },
          portableSolarPanels: {
            name: 'Portable Solar Panels',
            type: 'products',
            viewAllLink: '/product-category/portable-solar-panels',
            items: [
              {
                id: 'sp100',
                name: 'SP100W',
                specs: '100W Solar Panel',
                image: '/images/product/psp/SP100W.webp',
                link: '/products/sp100'
              },
              // {
              //   id: 'sp200',
              //   name: 'SP200',
              //   specs: '200W Solar Panel',
              //   image: '/images/product/psp/SP200.webp',
              //   link: '/products/sp200'
              // },
              {
                id: 'sp400',
                name: 'SP400W',
                specs: '400W Solar Panel',
                image: '/images/product/psp/SP400W.webp',
                link: '/products/sp400'
              }
            ]
          },
          accessories: {
            name: 'Accessories',
            type: 'products',
            viewAllLink: '/product-category/accessories',
            items: [
              {
                id: 't2-trolley',
                name: 'E3600LFP Trolley',
                specs: '(For E3600LFP)',
                image: '/images/product/accessory/t2-trolley.webp',
                link: '/products/t2-trolley'
              },
              {
                id: 'm18-air-lock',
                name: 'M18 Air Lock',
                specs: '5V2A',
                image: '/images/product/accessory/M18.webp',
                link: '/products/m18-air-lock'
              },
              {
                id: 'yc08-jump-starter',
                name: 'YC08 Jump Starter',
                specs: '7200mAh/26.64Wh',
                image: '/images/product/accessory/JumpStarter.webp',
                link: '/products/yc08-jump-starter'
              }
            ]
          }
        }
      }
      // byScenarios: {
      //   name: 'By Scenarios',
      //   type: 'multi-column',
      //   items: [
      //     {
      //       id: 'outdoor',
      //       name: 'Outdoor',
      //       image: '/images/scenarios/camping.webp',
      //       link: '/scenarios/outdoor'
      //     },
      //     {
      //       id: 'emergency',
      //       name: 'Emergency Backup',
      //       image: '/images/scenarios/emergency.webp',
      //       link: '/scenarios/emergency'
      //     }
      //   ]
      // }
    }
  },

  commercial: {
    name: 'Commercial',
    subcategories: {
      cess: {
        name: 'Commercial Energy Storage Systems',
        type: 'products',
        viewAllLink: '/product-category/commercial-storage',
        items: [
          {
            id: 'air-cooling-outdoor-cabinet',
            name: 'Air Cooling Outdoor Cabinet',
            specs: '125kW 296kWH',
            image: '/images/product/cess/air-cooling-outdoor-cabinet.webp',
            link: '/products/air-cooling-outdoor-cabinet'
          }
        ]
      }
    }
  },
  homeStorage: {
    name: 'Home Storage',
    subcategories: {
      homeBattery: {
        name: 'Home Batteries',
        type: 'products',
        viewAllLink: '/product-category/home-storage',
        items: [
          {
            id: 'home-battery',
            name: 'Home Batteries',
            specs: '13.5kWh',
            image: '/images/product/homeBattery/home-battery.webp',
            link: '/products/home-battery'
          }
        ]
      },
      inverter: {
        name: 'Inverters',
        type: 'products',
        items: [
          {
            id: 'g5000',
            name: 'G5000',
            specs: '550Vdc',
            image: '/images/product/inverter/inverter.webp',
            link: '/products/g5000'
          }
        ]
      }
    }
  },
  support: {
    name: 'Support',
    type: 'list',
    items: [
      { id: 'support-center', name: 'Support Center', link: '/support/support-center' },
      { id: 'downloads', name: 'Downloads', link: '/support/download' },
      { id: 'return-policy', name: 'Return and Exchange Policy', link: '/support/warranty' },
      { id: 'terms', name: 'Terms & Conditions', link: '/support/terms' }
    ]
  },
  about: {
    name: 'About',
    type: 'list',
    items: [
      { id: 'become-partner', name: 'Become a Partner', link: '/about/partner' },
      { id: 'our-story', name: 'Our Story', link: '/about/our-story' },
      { id: 'blog', name: 'Blog', link: '/about/blogs' },
      { id: 'media-press', name: 'Media Press', link: '/about/media' }
    ]
  }
};
